module.exports = __webpack_public_path__ + "img/suggestion_icon_book.b4b49396.svg";